import { jwtDecode } from 'jwt-decode';

class AuthService {
  isProtectedRoute() {
    const publicRoute = ['/inspectionpal'];
    const current = window.location.pathname;
    return !publicRoute.some((route) => current.startsWith(route));
  }
  checkTokenOnLoad() {
    const token = this.getToken();
    if (token && this.isTokenExpired(token) && this.isProtectedRoute()) {
      this.logout();
      window.location.assign('/login');
    }
  }
  getProfile() {
    // return jwtDecode(this.getToken());
    const token = this.getToken();
    if (!token || typeof token !== 'string') return { data: {} };
    try {
      return jwtDecode(token);
    } catch (err) {
      return { data: {} };
    }
  }

  loggedIn() {
    const token = this.getToken();
    return token && !this.isTokenExpired(token) ? true : false;
  }

  isTokenExpired(token) {
    try {
      const decoded = jwtDecode(token);
      if (decoded.exp < Date.now() / 1000) {
        this.logout();
        window.location.assign('/login');
        return true;
      }
      return false;
    } catch (err) {
      this.logout();
      window.location.assign('/login');
      return;
    }
  }

  getToken() {
    return localStorage.getItem('yoda_token');
  }

  login(idToken) {
    // console.log('Auth login called with token:', idToken);
    localStorage.setItem('yoda_token', idToken);
    // window.location.assign('/user');
  }

  logout() {
    localStorage.removeItem('yoda_token');
    localStorage.removeItem('temp_id');
    //window.location.assign('/');
  }
}
const authToken = new AuthService();
export default authToken;
